import styled from "styled-components";
import * as Color from "../../general/Color";

// TODO: Extract this into a common theme for inputs.

/**
 * A styled version of the text input component.
 */
export const StyledNativeInput = styled.input`
  font: inherit;
  color: inherit;
  text-decoration: inherit;
  line-height: inherit;

  padding: 0.4375rem 0.5rem;
  margin: 0;
  width: 100%;
  transition: border-color 0.2s ease;

  background-color: ${Color.toString(Color.White)};
  border: solid 1px ${Color.toString(Color.LightGrey[300])};
  border-radius: 0.25rem;
  display: block;

  &::placeholder,
  &:-ms-input-placeholder,
  &::-ms-input-placeholder {
    color: ${Color.toString(Color.LightGrey[400])}
  }

  &:focus,
  &:hover {
    outline: none;
  }

  &.invalid {
    border-color: ${Color.toString(Color.Red[600])};
  }

  &:read-only {
    background-color: ${Color.toString(Color.LightGrey[100])};
    border-color: ${Color.toString(Color.LightGrey[200])};
  }

  &:disabled {
    background-color: ${Color.toString(Color.LightGrey[200])};
    border-color: ${Color.toString(Color.LightGrey[200])};
    color: transparent;

    &::placeholder,
    &:-ms-input-placeholder,
    &::-ms-input-placeholder {
      color: transparent;
    }
  }

  &:not(:disabled) {
    &:not(:read-only) {
      &:focus {
        border-color: ${Color.toString(Color.Turqoise[400])};
      }

      &:hover {
        border-color: ${Color.toString(Color.LightGrey[700])};
      }
    }
  }
`;
